<template>
  <div>
    <v-app :style="colors">
      <header v-if="showHeader" class="app-header">
        <div class="app-header__inner">
          <div class="app-brand">
            <span class="brand-mark" aria-hidden="true">
              <v-icon dark>mdi-map-marker-path</v-icon>
            </span>
            <div class="app-brand__text">
              <span class="app-brand__name">{{ $config.projectName }}</span>
              <h1 class="app-header__title">{{ $route.meta.title }}</h1>
            </div>
          </div>
          <User />
        </div>
      </header>
      <v-main>
        <transition name="scale" mode="out-in">
          <router-view />
        </transition>
      </v-main>
      <!-- Shows the messages committed to the store (http interceptor, location errors, ...). -->
      <v-snackbar v-model="snackbar" class="app-snackbar" :color="$store.state.snackbarColor" :timeout="5000" top>
        {{ $store.state.snackbarMessage }}
      </v-snackbar>
    </v-app>
  </div>
</template>
<script>
import User from "./User.vue";

export default {
  components: { User },
  computed: {
    /**
     * Bound straight to the store (no local copy): a copy kept in sync by watchers drifted apart, and then the next
     * message did not show (opening an already "open" store snackbar changes nothing).
     */
    snackbar: {
      get() {
        return this.$store.state.snackbar;
      },
      set(value) {
        this.$store.commit("UPDATE_SNACKBAR", value);
        if (!value) this.$store.commit("UPDATE_SNACKBAR_MESSAGE", { message: "" });
      },
    },
    /** Exposes the theme colors as CSS variables (--primary-color, --secondary-color, ...). */
    colors() {
      const { colors } = this.$store.state.style;
      const cssVariables = {};
      Object.keys(colors).forEach((key) => {
        cssVariables[`--${key}-color`] = colors[key];
      });
      cssVariables["--list-background"] = `var(--${
        this.$store.state.dark ? "secondary" : "primary"
      }-color)`;
      return cssVariables;
    },
    /** The login screen has its own full-page design; every other screen gets the app header. */
    showHeader() {
      return this.$route.name != null && this.$route.name !== "login";
    },
  },
};
</script>
